<app-kontable title = "{{ 'common.supplier_title' | translate }}"
              [columns] = "['id', 'code', 'entity_name']"
              [titles] = "['common.id', 'common.code', 'common.entity_name']"
              [showInfoButton]="false"
              [showRecoverButton]="true"
              [showGlobalFilter]="false"
              [showDetailsButton]="false"
              [showAddButton]="true"
              [service]="svc"
              [(fireNewDataAvailable)]="newDatatableAvailable"
              [paginationType]="paginationType"
              [additionalRowCommands]="customRow"
              (onAdd)="showAddOrEditDialog($event)"
              (onEdit)="showAddOrEditDialog($event)"
              (onRemove)="delete($event)"
              (onRecover)="recover($event)">
    <ng-template #customRow data-testid="customRow" let-row>
        <p-button label="" pTooltip="{{ 'brandList.sectionTitle' | translate }}" icon="fa fas fa-hashtag" styleClass="ui-button-info" (onClick)="goToBrand(row)"></p-button>
        <p-button label="" pTooltip="{{ 'common.supplier_certifications' | translate }}" icon="fa fas fa-file" styleClass="ui-button-info" (onClick)="goToCertification(row)"></p-button>
    </ng-template>
</app-kontable>

<p-dialog *ngIf="svc.editing"
          [width]="500"
          [(visible)]="svc.editing"
          [responsive]="true"
          showEffect="fade"
          header="{{modalTitle}}"
          [modal]="true"
          (onHide)="onDialogHide()">

    <app-supplier-form [editingElement]="svc.editing"
                      (onAddElement)="onAddElement($event)"
                      (onUpdateElement)="onUpdateElement($event)">
    </app-supplier-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/supplier/supplier-list/supplier-list.component.html